module.exports = "/images/icon_social_tw_color.png?743c18e8a6dd623017f3cca58c6e4e31";